import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const primaryLocations = [
  { name: "Manchester", path: "/management/manchester/" },
  { name: "Liverpool", path: "/management/liverpool/" },
  { name: "London", path: "/management/london/" },
  { name: "Birmingham", path: "/management/birmingham/" },
  { name: "Stoke-on-Trent", path: "/management/stoke-on-trent/" },
];

const moreLocations = [
  { name: "Sheffield", path: "/management/sheffield/" },
  { name: "Newcastle", path: "/management/newcastle/" },
  { name: "Leeds", path: "/management/leeds/" },
  { name: "Chester", path: "/management/chester/" },
  { name: "Stockport", path: "/management/stockport/" },
  { name: "Brighton", path: "/management/brighton/" },
  { name: "Essex", path: "/management/essex/" },
  { name: "Oxford", path: "/management/oxford/" },
  { name: "Bath", path: "/management/bath/" },
  { name: "Slough", path: "/management/slough/" },
  { name: "Southampton", path: "/management/southampton/" },
];

const rowStyle = {
  display: "flex", alignItems: "center",
  fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 500,
  color: "#1A1A1A", textDecoration: "none",
  padding: "10px 12px", borderRadius: 8, transition: "background 0.15s",
};

export default function MobileLocationsAccordion({ onClose }) {
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <div style={{ paddingTop: 4, display: "flex", flexDirection: "column", gap: 2 }}>
      {primaryLocations.map((loc) => (
        <Link key={loc.name} to={loc.path} onClick={onClose} style={rowStyle}
          onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
        >
          {loc.name}
        </Link>
      ))}

      <button
        onClick={() => setMoreOpen(!moreOpen)}
        style={{
          ...rowStyle,
          justifyContent: "space-between",
          background: "none", border: "none", cursor: "pointer",
          color: "#888",
        }}
        onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
      >
        <span>More locations</span>
        <ChevronDown size={16} color="#888" style={{ transition: "transform 0.25s", transform: moreOpen ? "rotate(180deg)" : "rotate(0deg)" }} />
      </button>

      {moreOpen && moreLocations.map((loc) => (
        <Link key={loc.name} to={loc.path} onClick={onClose}
          style={{ ...rowStyle, paddingLeft: 20, fontSize: 14, color: "#4A4A4A" }}
          onMouseEnter={e => e.currentTarget.style.background = "#F7F7F5"}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
        >
          {loc.name}
        </Link>
      ))}
    </div>
  );
}